import {useDispatch, useSelector} from "react-redux";
import {
    dialogs,
    hideEditRoleDialog,
    loading,
    openManagePermissionsDialog,
    openPreviewRoleDialog,
    permissions,
} from "../../../store/slice";
import {useForm} from "../../../../../../shared/hooks/useForm";
import {TRole} from "../../../types";
import {useEffect} from "react";
import {EditAdminRole} from "../../../store/actions";

export const useEditRole = () => {
    const dispatch = useDispatch();

    const _permissions = useSelector(permissions);
    const {isOpen, role} = useSelector(dialogs).editRole;
    const {rolesUpdate} = useSelector(loading);

    useEffect(() => {
        if(isOpen && role){
            setForm(role);
        }else if(!isOpen){
            cleanUp();
        }
        //eslint-disable-next-line
    }, [isOpen]);

    const handleClose = () => {
        dispatch(hideEditRoleDialog());
    }

    const handleSubmit = () => {
        if(form.name.trim().length > 0 && form.permissions.length > 0){
            dispatch(EditAdminRole({role: form}));
        }
    }

    const {form, handleChange, setForm} = useForm<TRole>({
        name: '',
        permissions: [],
        system: true,
        origin: true,
        id: '',
        workspaceId: null,
        createDate: '',
        lastUpdateDate: ''
    });

    //actions
    const selectPermission = (permission: string) => {
        setForm({
            ...form,
            permissions: [...form.permissions, permission]
        })
    }

    const selectAllPermission = (permissions: string[]) => {
        // console.log(`SELECT ALL: ${permissions}`);
        setForm({
            ...form,
            permissions: Array.from(new Set([...form.permissions, ...permissions]))
        })
    }

    const deselectAllPermissions = (permissions: string[]) => {
        setForm({
            ...form,
            permissions: form.permissions.filter(e => !permissions.some(p => p === e))
        })
    }
    const deselectPermission = (permission: string) => {
        setForm({
            ...form,
            permissions: form.permissions.filter(e => e !== permission)
        })
    }

    //
    const handlePreviewSelectedPermissions = () => {
        dispatch(openPreviewRoleDialog({...form, id: '', workspaceId: null, system: false, createDate: '', lastUpdateDate: '', origin: true}))
    }

    //

    const handleOpenManagePermissionDialog = () => {
        dispatch(openManagePermissionsDialog());
    }

    const handleToggleSystem = () => {
        setForm({...form, system: !form.system});
    }

    const cleanUp = () => {
        setForm({
            name: '',
            permissions: [],
            system: true,
            origin: true,
            id: '',
            workspaceId: null,
            createDate: '',
            lastUpdateDate: ''
        })
    }

    return{
        isOpen,
        isLoading: rolesUpdate,
        handleClose,
        handleSubmit,
        isOk: JSON.stringify(form.permissions) !== JSON.stringify(role?.permissions) || form.system !== role?.system || form.origin !== role?.origin,
        form,
        handleChange,
        actions: {
            selectPermission,
            selectAllPermission,
            deselectAllPermissions,
            deselectPermission,
            handlePreviewSelectedPermissions,
            handleOpenManagePermissionDialog
        },
        permissions: _permissions,
        handleToggleSystem,
        role
    }
}